import { CFAuthGetRef } from "auth";
import moment from "moment";
import { locations } from '../../common/redux/action_locations';
import { GET_VERIFICATION_DATA } from './constants';

export function receivedGetAgentVerificationInfo(data) {
  let showAgentVerificationForm, showTwoStepVerificationPromptModal, lockedOutVerificationSent, lockedOutShowAgentVerificationForm = false;

  const currentDate = moment();
  const expirationDate = data.generatedEmailTokenExpirationDate;
  const validExpirationDate = expirationDate !== null;
  const verificationStartDate = data.verificationStartDate;
  const dateNotExpired = currentDate.isBefore(expirationDate, 'days');
  const hasEmailToken = data.generatedEmailToken !== null;
  const agentLockedOut = data.isLockedOut === true;
  const alternateLockedOut = currentDate.diff(verificationStartDate, 'days') > 7;
  const isVerified = data.isVerified;
  
  if(data.agentId === 0) {
    showAgentVerificationForm = true;
  } else {
    // show regular form screen
    showAgentVerificationForm = !hasEmailToken && !agentLockedOut && !isVerified;
    // show two-step verification modal
    showTwoStepVerificationPromptModal = hasEmailToken && validExpirationDate && dateNotExpired && !agentLockedOut && !alternateLockedOut;
    // show locked out screen
    lockedOutVerificationSent = (agentLockedOut || alternateLockedOut) && hasEmailToken && validExpirationDate && dateNotExpired;
    // show locked out form screen
    lockedOutShowAgentVerificationForm = (agentLockedOut && !hasEmailToken) || (validExpirationDate && !dateNotExpired);
  }

  return {
    type: 'RECEIVE_VERIFICATION_DATA',
    showAgentVerificationForm,
    showTwoStepVerificationPromptModal,
    agentLockedOut,
    lockedOutVerificationSent,
    lockedOutShowAgentVerificationForm,
    alternateLockedOut,
    agentVerificationInfo: data,
  };
}

export function getAgentVerificationInfoAction(filters) {
	return {
    type: GET_VERIFICATION_DATA,
    fetchCall: getAgentVerificationInfo,
    receivedAction: receivedGetAgentVerificationInfo,
    data: { locations, filters }
  }
}

function getAgentVerificationInfo(userID) {
  return CFAuthGetRef({
    url: `${process.env.REACT_APP_AP_API_URL}/AgentVerification/${userID}`,
    params: null,
    originURL: process.env.PUBLIC_URL,
    loaderName: ''
  });
}
  
export function reducer(state, { 
  type,
  showAgentVerificationForm,
  showTwoStepVerificationPromptModal,
  agentLockedOut,
  lockedOutVerificationSent,
  lockedOutShowAgentVerificationForm,
  agentVerificationInfo,
  alternateLockedOut,
}) {
  switch (type) {
    case 'RECEIVE_VERIFICATION_DATA':
      return {
        ...state,
        showAgentVerificationForm,
        showTwoStepVerificationPromptModal,
        agentLockedOut,
        lockedOutVerificationSent,
        lockedOutShowAgentVerificationForm,
        agentVerificationInfo,
        alternateLockedOut,

      }
    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/features/agent-info-verification/redux/getAgentVerificationInfo.js